<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
            <li><a href="#">首页</a></li>
            <li><a href="#">通讯录</a></li>
            <li><a href="#">客户分组</a></li>
            </ul>
        </div>
    
        <div class="formbody">
    
            <div class="formtitle"><span>客户分组</span></div>    
            <ul class="forminfo">   
                <li v-for="item,index in txlGroupList" style="padding-top:15px;">
                    <div class="groupings_l">{{item.groupname}}</div>
                    <div class="groupings_l">
                        <a href="#" @click="editTxlGroup(item.groupid,item.groupname)">编辑</a> &nbsp;&nbsp;  <a href="#" @click="delTxlGroup(item.groupid)">删除</a>
                    </div>
                </li>
                <div class="xline"></div>
                <li style="padding-top:15px;">
                <div class="groupings_l"> &nbsp; </div>
                <div class="groupings_l">
                <ul class="toolbars">
                    <li class="click" @click="addTxlGroup()">添加分组</li>
                </ul>
                </div>
                </li>  
            </ul>
        </div>
        <!--tip-->
        <div class="tip">
        
    	    <div class="tiptop"><span>添加分组</span><a></a></div>
        
            <div class="tipinfo cen ovhi">
      
                <div class="cen ovhi pat20">
                    <input v-show="false" v-model="txlgroup.groupid" />
                    <input name="" v-model="txlgroup.groupname" type="text" class="scinput" style="width:280px;"/>
                </div>
            
                <div class="cen lh33 ovhi">如果是请点击确定按钮 ，否则请点取消。</div>
                
                <div class="cen pat20 ovhi">
                    <input name="" type="button" @click="saveTxlGroup()"  class="sure"  value="  保  存  " />&nbsp;
                    <input name="" type="button" @click="close()"  class="cancel"  value="取消" />
                </div>
        
            </div>
    
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            //通讯录组
            txlGroupList:[],
            addgroupname:'',
            txlgroup:{
                groupid:'',
                groupname:'',
            },
        }
    },
    mounted(){
        this.getTxlGroupList();
    },
    methods:{
        getTxlGroupList(){
            var that = this
            let data = {'groupid':''}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/txl/gettxlgroup.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.txlGroupList = res.data.txlGroupList
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        editTxlGroup(groupid,groupname){
            this.txlgroup.groupid = groupid+'';
            this.txlgroup.groupname = groupname;
            $(".tip").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip").fadeOut(200);
            })
        },
        delTxlGroup(groupid){
            if(confirm('删除此通讯录分组，此通讯录分组下的客户也同时会被删除，确定要删除此分组吗？')){
                var that = this
                let data = {'groupid':groupid}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/txl/deletetxlgroup.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        alert("通讯录组删除成功！");
                        that.getTxlGroupList();
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
        },
        saveTxlGroup(){
            if(this.txlgroup.groupname.trim() == ''){
                alert("通讯录组名字不能为空！");
                return;
            }
            // console.log(typeof(this.txlgroup.groupid));
            if(this.txlgroup.groupid.trim() == ''){
                //添加
                var that = this
                let data = {'groupname':this.txlgroup.groupname,'status':1}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/txl/inserttxlgroup.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        alert("通讯录组添加成功！");
                        that.getTxlGroupList();
                        that.close();
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
            else{
                //修改
                var that = this
                let data = {'groupname':this.txlgroup.groupname,'groupid':this.txlgroup.groupid}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/txl/updatetxlgroup.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        alert("通讯录组修改成功！");
                        that.getTxlGroupList();
                        that.close();
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
        },
        addTxlGroup(){
            this.txlgroup.groupid = '';
            this.txlgroup.groupname = '';
            $(".tip").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip").fadeOut(200);
            })
        },
        close(){
            $(".tip").fadeOut(200);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/txl/txlgroup.vue